import React from 'react';

import { SignUpContainer } from '../../../modules/sign-up';

export const SignUp: React.FC = () => {
  return <SignUpContainer />;
};
SignUp.propTypes = {};
